
package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
actual data class AuthRequest(
    actual var userId: String? = null,
    actual var authorizationToken: String? = null,
)